document.addEventListener("DOMContentLoaded", function () {
  const heading = document.querySelector(".ts-table__heading");
  const body = document.querySelector(".ts-table__body");

  function syncScroll(source, target) {
    source.addEventListener("scroll", () => {
      target.scrollLeft = source.scrollLeft;
    });
  }

  syncScroll(heading, body);
  syncScroll(body, heading);
});
